import { html } from "../base/_utils";
import Offcanvas from "bootstrap/js/dist/offcanvas";

export default function navbarInit() {
    const navbar = document.querySelector(".navbar"); // entire nav container
    const mobileMenuToggle = document.querySelector(".animated-toggler");
    const bsOffcanvas = new Offcanvas("#offcanvas-navbar");
    const colorBlkPrimary = document.querySelector(".color-block-primary"); // red block
    const colorBlkSecondary = document.querySelector(".color-block-secondary"); // yellow block
    const navLogoLink = document.querySelector(".nav-logo-link"); // <a> containing logo
    const logoPrimary = document.querySelector(".center-primary"); // primary logo
    const logoN = document.querySelector(".center-n"); // plain 'N' logo
    const navItems = document.querySelectorAll(".nav-title"); // menu items (<li>)
    const giftBtn = document.querySelector(".nav-gift-btn"); // "make a gift" button
    const mobileNavBtn = document.querySelector(".navbar-toggler"); // mobile nav toggle btn
    let clicked = false; // track if mobile nav toggler has been clicked or not

    mobileMenuToggle.addEventListener("click", () => {
        mobileMenuToggle.classList.add("opened");
        // Delay mobile menu show until after toggle animation finishes
        setTimeout(() => {
            bsOffcanvas.show();
        }, 350);
    });

    // Remove .opened class from toggler after mobile menu finishes closing
    document.querySelector("#offcanvas-navbar").addEventListener("hidden.bs.offcanvas", () => {
        mobileMenuToggle.classList.remove("opened");
    });

    // // Giving Form Modal
    // const givingFormHTML = html`
    //     <div id="give-modal" class="modal fade" tabindex="-1">
    //         <div class="modal-dialog">
    //             <div class="modal-content">
    //                 <div class="modal-body position-relative p-0">
    //                     <button class="btn-close position-absolute top-0 end-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
    //                     <div id="blackbaud-donation-form_5d134e6b-ff3d-4d54-8cf2-666ec2e2e3ec"></div>
    //                     <script src="https://sky.blackbaudcdn.net/static/donor-form-loader/2/main.js"></script>
    //                     <script>
    //                         BBDonorFormLoader.newBlackbaudDonationFormZoned("tcs", "p-cdHl8nUeG0KQ_BTWgl_nqg", "5d134e6b-ff3d-4d54-8cf2-666ec2e2e3ec", "usa");
    //                     </script>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // `;

    // // Insert Giving Form Modal HTML before closing body tag
    // document.querySelector("main").insertAdjacentHTML("afterend", givingFormHTML);

    // if in mobile view, first time toggler is clicked, adds fixed-top and bg-white
    document.addEventListener("DOMContentLoaded", () => {
        if (window.innerWidth < 992) {
            for (let i = 0; i < navItems.length; i++) {
                navItems[i].classList.remove("px-2");
            }
        } else if (window.innerWidth >= 992) {
            giftBtn.style.top = "1.5rem";
        }

        mobileNavBtn.addEventListener("click", () => {
            clicked = true;
            navbar.classList.add("fixed-top", "bg-white");
        });
    });

    window.addEventListener("scroll", () => {
        let scrolled;
        clicked = false;

        // target which point in scrolling down to trigger effect
        if (window.scrollY > "300") {
            navbar.classList.add("fixed-top", "bg-white", "pb-lg-2", "mb-5", "shadow");

            // shrink color block
            colorBlkPrimary.style.cssText = "width: 3.7rem; height: 6.05rem";
            colorBlkSecondary.style.cssText = "width: 3.7rem; height: 1.5rem";

            // shrink menu items
            for (let i = 0; i < navItems.length; i++) {
                navItems[i].classList.add("nav-item-shrink");
            }

            // position "make a gift" btn
            if (window.innerWidth >= 992) {
                giftBtn.style.top = "1rem";
            }

            // switch/shrink nav logo
            navLogoLink.classList.add("logo-shrink");
            navLogoLink.classList.remove("logo-grow");
            logoPrimary.classList.add("d-none");
            logoN.classList.remove("d-none");

            scrolled = true;
        } else if (window.scrollY == 0) {
            navbar.classList.remove("shadow");

            // if in desktop view
            if (window.innerWidth >= 992) {
                navbar.classList.remove("fixed-top", "bg-white", "pb-lg-2", "mb-5");
                // grow color block to starting point
                colorBlkPrimary.style.cssText = "width: 6.75rem; height: 9.5rem";
                colorBlkSecondary.style.cssText = "width: 6.75rem; height: 3rem";

                // grow menu items to starting point
                for (let i = 0; i < navItems.length; i++) {
                    navItems[i].classList.replace("nav-item-shrink", "nav-item-grow");
                }

                if (window.innerWidth >= 992) {
                    giftBtn.style.top = "1.5rem";
                }

                navLogoLink.classList.replace("logo-shrink", "logo-grow");
                logoN.classList.add("d-none");
                logoPrimary.classList.remove("d-none");

                scrolled = false;
            } else if (
                // mobile view and nav toggler has been clicked
                window.innerWidth < 992 &&
                clicked
            ) {
                navbar.classList.add("fixed-top", "bg-white");
            } else if (
                // mobile view and nav toggler hasn't been clicked
                window.innerWidth < 992 &&
                !clicked
            ) {
                navbar.classList.remove("fixed-top", "bg-white");
            }
        }
    });
}
